export default "__VITE_ASSET__scNW2ubn__"